<template>
  <section ref="root" class="dc-container">
    <!-- Papel rasgado superior -->
    <div class="rasgado rasgado-top"></div>

    <!-- Fondo mágico de súper destellos y estrellas intensas (Sobre el fondo rosa) -->
    <div class="stars-container">
      <div class="stars sky-density-1"></div>
      <div class="stars sky-density-2"></div>
      <div class="stars sky-density-3"></div>
      
      <!-- Destellos cruzados de 4 puntas distribuidos -->
      <div class="glow-sparkle sp-1"></div>
      <div class="glow-sparkle sp-2"></div>
      <div class="glow-sparkle sp-3"></div>
      <div class="glow-sparkle sp-4"></div>
    </div>

    <!-- ===== ICONOS / IMÁGENES DECORATIVAS DE LAS ORILLAS ===== -->
    <img 
      ref="zapatillaTopLeft" 
      src="@/assets/zap.png" 
      alt="" 
      class="dc-zapatilla zapatilla-tl" 
    />
 
    <img 
      ref="zapatillaBottomLeft" 
      src="@/assets/bola.png" 
      alt="" 
      class="dc-zapatilla zapatilla-bl" 
    />

    <!-- CONTENIDO CENTRAL DE LA TARJETA -->
    <div class="dc-card">
      <!-- Título en dos líneas -->
      <h2 ref="title" class="dc-title">
        <span>Sugerencias</span><br />
        <span class="script">de Música</span>
      </h2>

      <!-- Ilustración central 
      <img
        ref="figure"
        src="@/assets/codigo.png"
        alt="Sugerencias musicales"
        class="dc-figure"
      />-->

      <!-- Pregunta Animada por Palabras -->
      <p ref="note" class="dc-note">
        ¿Qué canción te gustaría bailar esta noche? Envía tus propuestas por WhatsApp.
      </p>

      <!-- Botón elegante de WhatsApp -->
      <div ref="badge" class="btn-container">
        <a
          href="https://wa.me/17273254405"
          target="_blank"
          class="whatsapp-btn"
        >
Enviar propuesta        </a>
      </div>
    </div>

    <!-- Papel rasgado inferior -->
    <div class="rasgado rasgado-bottom"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'MusicRequestDressCodeStyle',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)
    
    // Refs para las imágenes decorativas
    const zapatillaTopLeft = ref(null)
    const zapatillaMidRight = ref(null)
    const zapatillaBottomLeft = ref(null)

    onMounted(async () => {
      await nextTick()
      if (!root.value) return

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 85%',
          once: true
        }
      })

      /* TÍTULO */
      tl.from(title.value, {
        opacity: 0,
        y: -24,
        filter: 'blur(6px)',
        duration: 0.6,
        ease: 'power3.out'
      })

      /* BADGE / BOTÓN (Configuración inicial de línea de tiempo) */
      tl.from(
        badge.value,
        {
          opacity: 0,
          y: 16,
          scale: 0.98,
          duration: 0.5,
          ease: 'back.out(1.6)'
        },
        '>-0.1'
      )

      /* ANIMACIÓN INICIAL DE LAS IMÁGENES DE LAS ORILLAS */
      tl.from([zapatillaTopLeft.value, zapatillaMidRight.value, zapatillaBottomLeft.value], {
        opacity: 0,
        scale: 0.6,
        duration: 0.7,
        stagger: 0.15,
        ease: 'back.out(1.4)'
      }, '>-0.2')

      /* FIGURA CENTRAL */
      tl.from(
        figure.value,
        {
          opacity: 0,
          scale: 0.9,
          duration: 0.55,
          ease: 'power2.out'
        },
        '>-0.3'
      )

      /* TEXTO ANIMADO PALABRA POR PALABRA */
      if (note.value) {
        const words = note.value.innerText.split(' ')
        note.value.innerHTML = words
          .map(word => `<span class="word">${word}</span>`)
          .join(' ')

        const wordSpans = note.value.querySelectorAll('.word')

        tl.from(
          wordSpans,
          {
            opacity: 0,
            y: 28,
            duration: 0.6,
            ease: 'power3.out',
            stagger: 0.12
          },
          '+=0.15'
        )
      }

      /* EFECTO INFINITO DE FLOTACIÓN (LOOP) EN LAS IMÁGENES */
      gsap.to(zapatillaTopLeft.value, {
        y: '+=8',
        rotation: '+=3',
        duration: 2.5,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })

      gsap.to(zapatillaMidRight.value, {
        y: '-=10',
        rotation: '-=4',
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 0.3
      })

      gsap.to(zapatillaBottomLeft.value, {
        y: '+=6',
        rotation: '+=4',
        duration: 2.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 0.6
      })
    })

    onUnmounted(() => {
      ScrollTrigger.refresh()
    })

    return { 
      root, 
      title, 
      badge, 
      figure, 
      note,
      zapatillaTopLeft,
      zapatillaMidRight,
      zapatillaBottomLeft
    }
  }
}
</script>

<style scoped>
.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background: #f0c9d3; /* Tu color rosa original */
  padding: 45px 18px 55px;
  overflow: hidden;
  text-align: center;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: #f0c9d3; /* Se unifica con tu fondo base */
  z-index: 3;
  pointer-events: none;
}
.rasgado-top {
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}
.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

/* Sistema de estrellas y destellos mágicos de fondo */
.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.stars {
  position: absolute;
  width: 100%;
  height: 100%;
  background: transparent;
}

/* Capas densas de destellos estrellados brillantes */
.sky-density-1 {
  background-image: 
    radial-gradient(2px 2px at 10% 15%, #fff 100%, transparent),
    radial-gradient(3px 3px at 25% 28%, #fff 80%, transparent),
    radial-gradient(2px 2px at 38% 12%, #fff 100%, transparent),
    radial-gradient(3px 3px at 68% 34%, #fff 80%, transparent),
    radial-gradient(2px 2px at 82% 10%, #fff 100%, transparent),
    radial-gradient(3px 3px at 92% 25%, #fff 80%, transparent),
    radial-gradient(2px 2px at 12% 55%, #fff 100%, transparent),
    radial-gradient(3px 3px at 42% 76%, #fff 80%, transparent),
    radial-gradient(2px 2px at 62% 58%, #fff 100%, transparent),
    radial-gradient(3px 3px at 88% 68%, #fff 80%, transparent);
  animation: ultraTwinkle 2s infinite ease-in-out alternate;
}

.sky-density-2 {
  background-image: 
    radial-gradient(2.5px 2.5px at 6% 38%, #fff, transparent),
    radial-gradient(3.5px 3.5px at 30% 20%, #fff, transparent),
    radial-gradient(2.5px 2.5px at 55% 22%, #fff, transparent),
    radial-gradient(3.5px 3.5px at 76% 42%, #fff, transparent),
    radial-gradient(2.5px 2.5px at 18% 72%, #fff, transparent),
    radial-gradient(3.5px 3.5px at 50% 85%, #fff, transparent),
    radial-gradient(2.5px 2.5px at 80% 80%, #fff, transparent);
  animation: ultraTwinkle 3.5s infinite ease-in-out alternate-reverse;
}

.sky-density-3 {
  background-image: 
    radial-gradient(7px 7px at 20% 18%, rgba(255,255,255,0.95) 0%, transparent 80%),
    radial-gradient(8px 8px at 72% 12%, rgba(255,255,255,0.9) 0%, transparent 80%),
    radial-gradient(7px 7px at 48% 70%, rgba(255,255,255,0.95) 0%, transparent 80%),
    radial-gradient(8px 8px at 84% 85%, rgba(255,255,255,0.95) 0%, transparent 80%);
  animation: ultraTwinkle 2.8s infinite ease-in-out;
}

/* Destellos reales de 4 puntas */
.glow-sparkle {
  position: absolute;
  width: 3px;
  height: 3px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 0 10px 2px #fff;
}
.glow-sparkle::before, .glow-sparkle::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(to right, transparent, #fff, transparent);
}
.glow-sparkle::before { width: 26px; height: 1.5px; }
.glow-sparkle::after { width: 1.5px; height: 26px; }

.sp-1 { top: 18%; left: 14%; animation: burst 4s infinite ease-in-out; }
.sp-2 { top: 32%; left: 85%; animation: burst 4.5s infinite ease-in-out 1s; }
.sp-3 { top: 72%; left: 25%; animation: burst 3.8s infinite ease-in-out 0.5s; }
.sp-4 { top: 58%; left: 76%; animation: burst 5s infinite ease-in-out 2s; }

@keyframes ultraTwinkle {
  0% { opacity: 0.3; transform: scale(0.95); }
  50% { opacity: 1; transform: scale(1.05); filter: drop-shadow(0 0 3px #fff); }
  100% { opacity: 0.4; transform: scale(0.97); }
}

@keyframes burst {
  0%, 100% { transform: scale(0); opacity: 0; }
  50% { transform: scale(1.2); opacity: 1; }
}

/* Estructura central */
.dc-card {
  position: relative;
  z-index: 2;
}

.dc-title {
  font-family: 'britishgruesa', cursive;
  font-size: 66px;
  color: #ffffff;
  margin: 0 0 16px;
  line-height: 1.05;
}

.dc-title .script {
  opacity: 0.9;
}

.dc-figure {
  width: 180px;
  margin: 10px auto 12px;
  display: block;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.15));
}

.dc-note {
  font-family: 'quote', serif;
  font-size: 20px;
  color: #ffffff;
  opacity: 0.9;
  font-style: italic;
  margin: 10px auto 18px;
}

/* Contenedor del Botón */
.btn-container {
  display: inline-block;
  margin: 4px 0 12px;
}

/* Botón elegante de WhatsApp estilo Badge */
.whatsapp-btn {
  display: inline-block;
  background: #ffffff;
  color: #25D366; /* Texto verde WhatsApp sobre fondo blanco premium */
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 0.05em;
  padding: 10px 22px;
  border-radius: 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  text-decoration: none;
  transition: all 0.3s ease;
}

.whatsapp-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  background: #f7f7f7;
}

/* ===== ESTILOS E IMÁGENES DE LAS ORILLAS (ZAPATILLAS, FLORES, ICONOS) ===== */
.dc-zapatilla {
  position: absolute;
  height: auto;
  z-index: 1;
  opacity:  0 !important;
  pointer-events: none;
}

.zapatilla-tl {
  top: 50px;  
  width: 180px;
  opacity: 0 !important; /* Mantiene tu configuración original */
  left: 10px;
  transform: rotate(-15deg);
}

.zapatilla-mr {
  top: 45%;
  right: -18px;
  width: 180px;
}

.zapatilla-bl {
  top: -15px !important;
  left: -52px;  
  width: 180px;
}

/* Control del texto animado */
.word {
  display: inline-block;
  white-space: nowrap;
}
</style>